import { Modal } from 'react-bootstrap';
import { GRAPHITE_COLOR, LG_COLOR, MAIN_BLUE_COLOR } from 'containers/App/constants';
import styled from 'styled-components';

export const LayoutFormStyles = styled(Modal)`
  .modal-dialog {
    width: min(960px, calc(100vw - 32px));
    max-width: none;
  }

  .modal-content {
    border: 0;
    border-radius: 8px;
    box-shadow: 0 18px 48px rgba(65, 70, 80, 0.18);
    overflow: hidden;
  }

  .modal-header {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
    padding: 16px 20px;
  }

  .modal-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.05rem;
    font-weight: 700;
  }

  .modal-body {
    background: #fff;
    max-height: min(72vh, 760px);
    overflow: auto;
    padding: 20px;
  }

  .modal-footer {
    border-top: 1px solid #d9dde3;
    padding: 14px 20px;
  }

  .faded {
    opacity: 0.7;
  }

  .command-title {
    max-width: calc(100% - 7em);
  }

  .control-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    background: #f8f9fb;
    color: ${GRAPHITE_COLOR};
    cursor: pointer;
    min-height: 48px;
  }

  .command-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-color: #e3e7ec;
    color: ${GRAPHITE_COLOR};
    gap: 12px;
  }

  .card {
    border: 1px solid #dde2e8;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
  }

  .card-body {
    background: #fff;
    display: grid;
    gap: 10px;
  }

  .card-body + .btn,
  .modal-body > .btn {
    margin-bottom: 12px;
  }

  .action-group {
    display: inline-flex;
    gap: 8px;
  }

  .rs-btn-icon.rs-btn-circle {
    align-items: center;
    background: #fff;
    border: 1px solid #dde2e8;
    color: ${GRAPHITE_COLOR};
    display: inline-flex;
    height: 32px;
    justify-content: center;
    width: 32px;
  }

  .rs-btn-icon.rs-btn-circle:hover {
    border-color: ${LG_COLOR};
    color: ${LG_COLOR};
  }

  .form-group {
    display: flex;
    width: 100%;

    .form-label {
      width: 30%;
    }

    .form-control,
    .form-input {
      width: 70%;
    }

    .form-control:focus,
    .form-input:focus {
      border-color: ${MAIN_BLUE_COLOR};
      box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
    }
  }

  @media (max-width: 720px) {
    .form-group {
      display: block;

      .form-label,
      .form-control,
      .form-input {
        width: 100%;
      }
    }
  }
`;
